import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  PriceSummaryAction,
  PriceSummaryComponent as DsPriceSummaryComponent,
  PriceSummaryGroup,
} from '@voyagu/portal-design-system';

import {
  PortalAncillaryBundle,
  PortalOrderNode,
  PortalTierEnum,
} from '@app/services/api/api.types';

import { buildPriceSummary } from './price-summary.util';

const defaultSubtitle = 'Rates are quoted in US dollars';

@Component({
  selector: 'price-summary',
  standalone: true,
  imports: [DsPriceSummaryComponent],
  templateUrl: './price-summary.component.html',
  styleUrls: ['./price-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceSummaryComponent implements OnChanges {
  @Input() option: PortalOrderNode;
  @Input() tier?: PortalTierEnum;
  @Input() bundle?: PortalAncillaryBundle;
  @Input() disruptionProtection?: number;
  @Input() tipsAmount?: number;
  @Input() cancelForAnyReason?: number;
  @Input() promocodeDiscountAmount?: number;
  @Input() referralCreditDiscount?: number;
  @Input() subtitle?: string;
  @Input() actions: PriceSummaryAction[] = [];

  @Output() actionClick = new EventEmitter<PriceSummaryAction>();

  totalLabel = '';
  groups: PriceSummaryGroup[] = [];

  ngOnChanges() {
    if (!this.option) {
      this.totalLabel = '';
      this.groups = [];
      return;
    }

    const view = buildPriceSummary({
      option: this.option,
      tier: this.tier,
      bundle: this.bundle,
      disruptionProtection: this.disruptionProtection,
      tipsAmount: this.tipsAmount,
      cancelForAnyReason: this.cancelForAnyReason,
      promocodeDiscountAmount: this.promocodeDiscountAmount,
      referralCreditDiscount: this.referralCreditDiscount,
    });

    this.totalLabel = view.total;
    this.groups = view.groups;
  }

  get resolvedSubtitle() {
    return this.subtitle || defaultSubtitle;
  }

  onActionClick(action: PriceSummaryAction) {
    this.actionClick.emit(action);
  }
}
